import * as React from "react";

export const Config = {
    Email : "info@najsu.com",
    BookingRequestUrl : "https://najsu.com/agency-booking-email.php",
    ShowcaseLink : "https://www.figma.com/proto/12gvX83mya2lD8KJAUx9km/Najsu-agency-sample-work?page-id=0%3A1&node-id=1-2&viewport=255%2C313%2C0.19&t=nejLdagreTb0BJCH-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=1%3A2",
    PageSections : {
        HowItWorks : "how-it-works",
        Services : "services",
        Pricing : "pricing",
        Templates : "templates",
        Testimonials : "testimonials",
        WorkThatWorks : "our-works",
        FAQ : "faq",
        Booking : "book-a-call"
    },
    PageLinks : {
        TermsAndConditions : "/terms-and-conditions",
        PrivacyPolicy : "/privacy-policy"
    },
    SocialsLinks : {
        Twitter : "https://x.com/Marki_Tweet",
        Dribble : "https://dribbble.com/tiny_marki"
    },
    LogosToShowcase : [
        process.env.PUBLIC_URL + '/assets/logos/lakioo.png',
        process.env.PUBLIC_URL + '/assets/logos/traininghub.png',
        process.env.PUBLIC_URL + '/assets/logos/smartsupp.png',
        process.env.PUBLIC_URL + '/assets/logos/Your future logo.png',
        process.env.PUBLIC_URL + '/assets/logos/customerscore.png',
        process.env.PUBLIC_URL + '/assets/logos/zpsx.png',
        process.env.PUBLIC_URL + '/assets/logos/ucime-prvni-pomoc.png'
    ],
    CarouselProjects : [
        { url : process.env.PUBLIC_URL + '/assets/hero_section/01.webp', altText : "Dark-themed SaaS website for a productivity app with hero headline, pricing plans, testimonials, FAQ, and feature highlights made in Framer no-code."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/02.webp', altText : "Hero section design for a van rental service. The layout features a headline, a search bar, brand logos, customer testimonial, and a photo of a vintage blue van parked by the ocean."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/03.webp', altText : "Figma landing page design for Black Friday promotional campaign showing live chat features, countdown timer, and pricing plans comparison."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/04.webp', altText : "Responsive web design for a plant store shown on a laptop, tablet, and mobile phone."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/05.webp', altText : "Dashboard of a web application showcasing project management and team overview features."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/06.webp', altText : "A clean, minimalist product page for a furniture store. The page features price, color options, and product details."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/07.webp', altText : "Help Center or Knowledge base Figma design for a SaaS company featuring a search bar and categorized help articles."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/08.webp', altText : "A dark-themed sign-up screen for a newsletter. It features a newsletter signup form with fields for name, email, and a 'Sign Up' button."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/09.webp', altText : "Project detail screen for an architecture studio showing project description, small detail images, and a large exterior view of the modern building."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/10.webp', altText : "A pricing page featuring two service tiers, each outlining key features."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/11.webp', altText : "A project detail page of a portfolio website displaying a grid of four photos. The page includes project details and a description."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/12.webp', altText : "A dark-themed bento grid layout featuring various informational cards about memory and neuroscience."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/13.webp', altText : "Landing page design for an AI Shopping Assistant feature for a SaaS tool."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/14.webp', altText : "Hero section for an AI-powered learning platform featuring navigation, a call-to-action to register to the platform, and three content cards showcasing courses."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/15.webp', altText : "Hero section for an AI-generated image platform (AI SaaS), featuring the bold headline and call to action buttons alongside four example AI-generated portrait images in a staggered grid layout."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/16.webp', altText : "A services section for a neuroscience agency working on AI-assisted memory rebuilding. The main section features the headline and four service cards."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/17.webp', altText : "Website design for a yoga and wellness center. The design showcases different sections like classes, testimonials and schedule with images and descriptions as well as highlights effortless booking."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/18.webp', altText : "Hero section for a mind-tech fusion company, featuring the headline, three abstract glowing images related to cognition and technology and calls to action."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/19.webp', altText : "About section for a design agency, with the headline, and three images below it introducing the offering. 'Our Services' section lists additional offerings."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/20.webp', altText : "Newsletter design for a medical startup. The design features several content sections with call-to-action buttons inviting user to learn more about the topic."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/21.webp', altText : "Hero section design for a performance sportswear brand with bold tagline and dynamic athlete imagery with motion blur, showcasing athletic fashion."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/22.webp', altText : "Hero section design for a neuroscience and mental health agency with a bold headline, social proof that builds trust and call-to-action button that stands out."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/23.webp', altText : "Landing page design for a SaaS application focused on customer retention and churn prediction with a dashboard illustration in the hero section awe well as custom illustrations showcasing product features and usage of the product."},
        { url : process.env.PUBLIC_URL + '/assets/hero_section/24.webp', altText : "Hero section for a neuroscience agency in dark mode featuring engaging imagery suggesting advanced technology. The layout, ideal for a modern website, features clear navigation and a prominent call-to-action button."}
    ],
    PricingPackages : {
        SinglePackage : {
            Basic : 1100,
            Additional : 1200
        },
        MultiPackage : {
            Basic : 2300,
            Additional : 1200
        },
        SubscriptionPackage : {
            Basic : 3800,
            Additional : 2000
        }
    },
    FramerTemplates : [
        {
            name : "ZenTask",
            price : "$59",
            imageUrl : "/assets/templates/zentask.webp",
            imageUrlHover : "/assets/templates/zentask_hover.webp",
            categories : ["SaaS", "Startup"],
            badge : "Popular",
            badgeClass : "popular",
            link : "https://buy.polar.sh/polar_cl_SJ703NP0uQUsdC1xxQFZT1iEVNUYHHc89wryB0dMQ5g"
        },
        {
            name : "Theo",
            price : "$59",
            imageUrl : "/assets/templates/theo.webp",
            imageUrlHover : "/assets/templates/theo_hover.webp",
            categories : ["Portfolio"],
            link : "https://buy.polar.sh/polar_cl_I8T1JuUWaXxJZueLZIxQc0HfZqBf7z2a3Yh7x1K86i1"
        },
        {
            name : "Mona",
            price : "$12",
            imageUrl : "/assets/templates/mona.webp",
            imageUrlHover : "/assets/templates/mona_hover.webp",
            categories : ["Bio Site"],
            badge : "New",
            badgeClass : "new",
            link : "https://buy.polar.sh/polar_cl_bu9oCCASRm1pV9qlWaTQyXQ2ZNnhJagWVjOxv01hUN2"
        },
        /*{
            name : "Template",
            price : "$0.00",
            categories : ["Category"],
            badge : "in progress",
            badgeClass : "grey",
            link : ""
        }*/
    ]
}
